import { DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR } from '@/constants/ui';
import React from 'react';

const MYOMentalDomain = ({
  color,
  size = 50,
  background = DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR,
}: {
  color: string;
  size?: number;
  background?: string;
}) => (
  <svg viewBox="0 0 100 100" width={size} height={size} fill={'none'}>
    <rect width="100" height="100" rx="18" fill={background} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M73.5232 39.681C71.796 26.3224 60.3788 16 46.5477 16C31.5265 16 19.3477 28.1788 19.3477 43.2C19.3477 49.6328 21.5815 55.5454 25.3181 60.2034C28.0653 63.6306 29.5477 67.4284 29.5477 71.4404V84H60.1476L60.1511 73.8H66.9476C70.7046 73.8 73.7476 70.757 73.7476 67V57.038L80.4082 54.1888C81.5744 53.6856 81.6764 52.5058 81.1732 51.7136L73.5232 39.681ZM59.5854 47.2322V40.0122C59.5854 39.8837 59.5344 39.7606 59.4436 39.6698C59.3527 39.5789 59.2296 39.5279 59.1011 39.5279H50.932V31.3588C50.932 31.2304 50.881 31.1072 50.7902 31.0164C50.6994 30.9256 50.5762 30.8746 50.4478 30.8746H43.223C43.0945 30.8746 42.9714 30.9256 42.8806 31.0164C42.7897 31.1072 42.7387 31.2304 42.7387 31.3588V39.5279H34.5696C34.4412 39.5279 34.318 39.5789 34.2272 39.6698C34.1364 39.7606 34.0854 39.8837 34.0854 40.0122V47.2322C34.0854 47.3606 34.1364 47.4838 34.2272 47.5746C34.318 47.6654 34.4412 47.7164 34.5696 47.7164H42.7387V55.8855C42.7387 56.0139 42.7897 56.1371 42.8806 56.2279C42.9714 56.3187 43.0945 56.3697 43.223 56.3697H50.4478C50.5762 56.3697 50.6994 56.3187 50.7902 56.2279C50.881 56.1371 50.932 56.0139 50.932 55.8855V47.7164H59.1011C59.2296 47.7164 59.3527 47.6654 59.4436 47.5746C59.5344 47.4838 59.5854 47.3606 59.5854 47.2322Z"
      fill={color}
    />
  </svg>
);

export default MYOMentalDomain;
